import { Contract, getContractsEndpoint } from 'cpie-common';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-15/common-utilities';
import { getSimpleDataFetchSlice } from '@cp-shared-15/frontend-integration';
import { CpDataApi } from 'cp-xhr';

const { reducer, fetchData } = getSimpleDataFetchSlice<Contract[], DefaultBusinessMarketApiErrorCode>({
    dataName: 'contracts',
    fetchCallback() {
        return CpDataApi.get(getContractsEndpoint()).then(response => response.data);
    },
});

export default reducer;
export const fetchContracts = fetchData;
